(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paperloops-home-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const revealTrialFromHash = () => {
    if (window.location.hash !== '#home-trial-details') return;
    const details = document.querySelector('#home-trial-details');
    if (details) details.open = true;
  };
  const initialise = () => {
    revealTrialFromHash();
    document.querySelectorAll('[data-home-carousel]').forEach(root => {
      if (root.dataset.carouselBound) return;
      root.dataset.carouselBound = '1';
      const track = root.querySelector('[data-carousel-track]');
      const cards = [...root.querySelectorAll('[data-carousel-card]')];
      const previous = root.querySelector('[data-carousel-prev]');
      const next = root.querySelector('[data-carousel-next]');
      const position = root.querySelector('[data-carousel-position]');
      if (!track || !cards.length || !previous || !next) return;
      track.tabIndex = 0;
      track.setAttribute('aria-label', root.querySelector('h2')?.textContent || '');
      const metrics = () => {
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const step = cards[0].getBoundingClientRect().width + gap;
        const visible = Math.max(1, Math.floor((track.clientWidth + gap + 2) / step));
        return {step, visible, first:Math.round(track.scrollLeft / step)};
      };
      const update = () => {
        const {visible,first} = metrics();
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
        const end = Math.min(cards.length, first + visible);
        const current = end > first + 1 ? (first + 1) + '–' + end : String(first + 1);
        if (position) position.textContent = root.dataset.positionLabel.replace('__CURRENT__',current).replace('__TOTAL__',String(cards.length));
      };
      const move = direction => {
        const {step,visible} = metrics();
        track.scrollBy({left:direction * step * visible,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click',() => move(-1));
      next.addEventListener('click',() => move(1));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}
      });
      window.addEventListener('resize',update,{passive:true});
      update();
    });
    document.querySelectorAll('[data-home-video]').forEach(shell => {
      if (shell.dataset.videoBound) return;
      shell.dataset.videoBound = '1';
      const video = shell.querySelector('video');
      const button = shell.querySelector('[data-video-play]');
      if (!video || !button) return;
      button.addEventListener('click',async () => {
        document.querySelectorAll('[data-home-video]').forEach(other => {
          if (other !== shell) {other.querySelector('video')?.pause();other.classList.remove('is-playing');}
        });
        try {await video.play();shell.classList.add('is-playing');video.focus({preventScroll:true});} catch (error) {shell.classList.remove('is-playing');}
      });
      video.addEventListener('ended',() => shell.classList.remove('is-playing'));
    });
    document.querySelectorAll('[data-home-trial]').forEach(link => {
      if (link.dataset.trialBound) return;
      link.dataset.trialBound = '1';
      link.addEventListener('click',event => {
        const details = document.querySelector('#home-trial-details');
        if (!details) return;
        event.preventDefault();details.open = true;
        details.querySelector('summary')?.focus({preventScroll:true});
        details.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise,{once:true}); else initialise();
  document.addEventListener('shopify:section:load',initialise);
  window.addEventListener('hashchange',revealTrialFromHash);
})();
  } catch(e) { console.error(e); }
})();

})();
